import { Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import SfLoadingSkeleton from "../Loadings/SfLoadingSkeleton";
import BootstrapTable from "react-bootstrap-table-next";
import { generateFormattedCodeForMacro, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import { SF_PAYLOAD_FORMATTERS } from "helpers/sf_constants";
import { customSortCaret } from "helpers/bootstrap_table_helper";


const FormattersModal = ({ title, show, onAddClick, onCloseClick, CTAButtonText, macro }) => {

  const [formattedCode, setFormattedCode] = useState("")
  const loading = false

  useEffect(() => {
    const key = macro ? `{{ ${macro} }}` : "";
    setFormattedCode(key)
  }, [macro])

  const formatter_columns = [
    {
      dataField: "formatter_name",
      text: "Formatter",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <div className='text-sfblue' style={{ cursor: 'pointer' }} onClick={() => setFormattedCode(generateFormattedCodeForMacro(macro, cell))}>{cell}</div>
        );
      }
    },
    {
      dataField: "formatter_description",
      text: "Description",
      sort: true,
    },

  ]

  const formatter_data = SF_PAYLOAD_FORMATTERS;

  const defaultSorted = [{
    dataField: 'name',
    order: 'asc',
  }];

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size='lg'>
      <ModalHeader>
        <div className="d-flex justify-content-center">
          <i className={`align-self-bottom label-title bx bx-news ${getPrimaryTextClass()} me-1`}></i>
          <span className="modal-title text-black font-weight-semibold">
            {title}
          </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Row>
          <div className="table-responsive">
            <ToolkitProvider
              keyField="id"
              columns={formatter_columns}
              data={formatter_data}

            >
              {(toolkitProps) => (
                <>
                  <Col lg="12">
                    <div
                    >
                      {loading ? (
                        <SfLoadingSkeleton rows={8} cols={2} />
                      ) : (
                        <BootstrapTable
                          keyField="id"
                          columns={formatter_columns}
                          data={formatter_data}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          rowClasses="tr-hover"
                          headerClasses="sftableHeader text-black align-middle"
                          classes="table align-middle table-nowrap text-black"
                          headerWrapperClasses="thead-light"
                          noDataIndication="You currently don't have any lead integration macro mappings"
                          sort={{ sortCaret: customSortCaret }}
                          {...toolkitProps.baseProps}
                        />
                      )}
                    </div>
                  </Col>

                </>
              )}
            </ToolkitProvider>
            <FormGroup className="my-3">
              <Label className="form-control-label font-weight-semibold">Formatted Expression</Label>
              <Input type="textarea" value={formattedCode} />
            </FormGroup>
          </div>
        </Row>
      </ModalBody>
      <ModalFooter>
        <div className="text-center mt-3">
          <button
            type="button"
            className={`btn ${getPrimaryButtonClass()} ms-2`}
            onClick={() =>
              onAddClick(formattedCode)}
          >
            {CTAButtonText || "Add"}
          </button>
          <button
            type="button"
            className="btn btn-light ms-2"
            onClick={onCloseClick}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

FormattersModal.propTypes = {
  onCloseClick: PropTypes.func,
  onAddClick: PropTypes.func,
  show: PropTypes.any,
  title: PropTypes.any,
  CTAButtonText: PropTypes.any,
  macro: PropTypes.any,
}

export default FormattersModal;

